module.exports = __webpack_public_path__ + "static/media/diageo_footer-logo.1abf3ce2.png";